// extracted by mini-css-extract-plugin
module.exports = {"alert":"whz49Lc6"};